import { ReducerRegistry } from 'store';
import {
  FETCH_DASHBOARD_SUMMARY,
  DASHBOARD_ASYNC_START,
  DASHBOARD_ASYNC_END,
  DASHBOARD_LOG_ERROR,
  UPDATE_DASHBOARD_FILTERS,
  UPDATE_DASHBOARD_PAGINATION,
  FETCH_DASHBOARD_TRANSACTIONS,
  FETCH_TRANSACTIONS_FROM_SOURCE,
  FETCH_WALLET_BALANCE,
  CLEAR,
  CHECk_ACCOUNT_STATUS,
  FETCH_OVERVIEW_GRAPH,
  FETCH_TRANSACTION_AMOUNT,
  FETCH_TRANSACTION_VOLUME,
} from '../types';

const INIT_STATE = {
  summary: {
    data: {
      totalTransactions: 0,
      totalSuccessfulTransactions: 0,
      totalFailedTransactions: 0,
      totalAmountReceived: 0,
    },
    inProgress: false,
    error: '',
  },
  transactions: {
    data: [],
    pagination: { page: 1, limit: 6 },
    inProgress: false,
    error: '',
  },
  transactionsFromSource: {
    data: [],
    pagination: { page: 1, limit: 6 },
    inProgress: false,
    error: '',
  },
  accountChecker: {
    inProgress: false,
  },
  report: {
    inProgress: false,
  },
  filters: {},
  walletBalance: 0,
  graph: {
    data: [],
    inProgress: false,
  },
  transactionAmount: {
    inProgress: false,
  },
  transactionVolume: {
    inProgress: false,
  },
};

export const productReducer = ReducerRegistry.register(
  'dashboard',
  (state = INIT_STATE, { type, payload, subType }) => {
    switch (type) {
      case FETCH_DASHBOARD_SUMMARY:
        return {
          ...state,
          summary: {
            ...state.summary,
            data: payload,
            inProgress: false,
          },
        };

      case FETCH_OVERVIEW_GRAPH:
        return {
          ...state,
          graph: {
            ...state.graph,
            data: payload,
            inProgress: false,
          },
        };
      case FETCH_TRANSACTION_AMOUNT:
        return {
          ...state,
          transactionAmount: {
            ...payload,
            inProgress: false,
          },
        };
      case FETCH_TRANSACTION_VOLUME:
        return {
          ...state,
          transactionVolume: {
            ...payload,
            inProgress: false,
          },
        };

      case FETCH_DASHBOARD_TRANSACTIONS:
        return {
          ...state,
          transactions: {
            ...state.transactions,
            data: payload.list,
            pagination: {
              ...state.transactions.pagination,
              ...payload.pagination,
            },
            inProgress: false,
          },
        };

      case FETCH_TRANSACTIONS_FROM_SOURCE:
        return {
          ...state,
          transactionsFromSource: {
            ...state.transactionsFromSource,
            data: payload.list,
            pagination: {
              ...state.transactionsFromSource.pagination,
              ...payload.pagination,
            },
            inProgress: false,
          },
        };

      case DASHBOARD_ASYNC_START:
        return {
          ...state,
          [subType]: {
            ...state[subType],
            inProgress: true,
          },
        };

      case DASHBOARD_ASYNC_END:
        return {
          ...state,
          [subType]: {
            ...state[subType],
            inProgress: false,
          },
        };

      case UPDATE_DASHBOARD_FILTERS:
        return {
          ...state,
          filters: {
            ...state.filters,
            ...payload,
          },
        };

      case FETCH_WALLET_BALANCE:
        return {
          ...state,
          walletBalance: payload,
        };

      case CHECk_ACCOUNT_STATUS:
        return {
          ...state,
          accountChecker: { ...payload, inProgress: false },
        };

      case UPDATE_DASHBOARD_PAGINATION:
        return {
          ...state,
          [subType]: {
            ...state[subType],
            pagination: {
              ...state[subType].pagination,
              page: payload,
            },
          },
        };

      case DASHBOARD_LOG_ERROR:
        return {
          ...state,
          [subType]: {
            ...state[subType],
            inProgress: false,
            error: payload,
          },
        };

      case CLEAR:
        return INIT_STATE;

      default:
        return state;
    }
  },
);
